import { render } from "./OrganizationIcon.vue?vue&type=template&id=18807076"
import script from "./OrganizationIcon.vue?vue&type=script&lang=js"
export * from "./OrganizationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__